import { getDigitalWellBeingPreviewPath } from 'utils/digitalWellBeingHelpers'
import { getCourseInstancePath } from 'components/dashboard/ClassCard/helpers'

import { UNIT_ROUTE_PRODUCT_NAMES } from './constants'

export function courseSelectHandlerFactory(productName, navigationEvent) {
  return courseOrSlug => () => {
    if (productName === 'digital-well-being') {
      return navigationEvent(
        getDigitalWellBeingPreviewPath({ course: courseOrSlug }),
      )
    }

    return navigationEvent(
      `/product/${productName}/lessons/preview/${courseOrSlug}`,
    )
  }
}

export function classSelectHandlerFactory(productName, navigationEvent) {
  return (course, instance) => () => {
    const usesUnitRoute = UNIT_ROUTE_PRODUCT_NAMES.includes(productName)

    if (usesUnitRoute) {
      const path = getCourseInstancePath({
        program: productName,
        gradeDisplayTitle: course,
        instance,
        tier: 1,
      })
      navigationEvent(path)
      return
    }

    navigationEvent(
      `/product/${productName}/lessons/teach/${course}?class=${instance}`,
    )
  }
}

export function gotoDashboardHandlerFactory(navigationEvent) {
  return () => navigationEvent('/')
}
